import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Nullable } from 'common/types'

import type { SelectedTreeObject } from '../../types'

type InitialStateType = { activeEntity: Nullable<SelectedTreeObject> }

const initialState: InitialStateType = { activeEntity: null }

export const treeSlice = createSlice({
  name: 'tree',
  initialState,
  reducers: {
    setActiveEntity(state, { payload }: PayloadAction<Nullable<SelectedTreeObject>>) {
      state.activeEntity = payload
    },
  },
})

export default treeSlice.reducer
